import React, { useState, useEffect, useContext } from "react";

import { Paper } from "@material-ui/core";

import useMediaQuery from "@material-ui/core/useMediaQuery";

import { useStyles } from "./style";

import DateFnsUtils from "@date-io/date-fns";

import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import {
  EnhancedTableToolbar,
  CardItem,
} from "../../../components/pages/reports/ipCreditNoteReport/index";

import { IPCreditNoteReportContext } from "../../../context/states/reports/ipCreditNoteReportState";

const initialState = {
  isSearch: false,

  interpreter: null,

  fromDate: null,

  toDate: null,

  businessType: "",
};

const IPCreditNoteReport = () => {
  const classes = useStyles();

  const matches = useMediaQuery("(min-width:1920px)");

  const {
    creditNotes,
    totalAmount,
    totalVAT,
    totalCredit,
    interpreters,
    count,
    loading,
    getInterpretersHandler,
    getCreditNoteReportHandler,
    clearCreditNoteStateHandler,
  } = useContext(IPCreditNoteReportContext);

  const [values, setValues] = useState({
    ...initialState,
  });

  const [dense] = useState(true);

  useEffect(() => {
    getCreditNoteReportHandler("");
  }, []);

  // Handle Inputs
  const handleChange = (event) => {
    const { name, checked, value, type } = event.target;

    setValues((prev) => ({
      ...prev,

      [name]:
        name === "businessType"
          ? checked
            ? "Private"
            : ""
          : type === "checkbox"
            ? checked
            : value,
    }));
  };

  // Handle Interpreter Autocomplete
  const handleChangeAutoComplete = (name) => (event, value) => {
    if (name === "interpreter") {
      setValues((prev) => ({
        ...prev,
        interpreter: value || null,
      }));
    }
  };

  const handleInterpreterInputChange = (event, value, reason) => {
    if (reason !== "input") return;

    if (!value || value.trim() === "") {
      return;
    }

    getInterpretersHandler(value);
  };

  // Handle From Date
  const handleFromDateChange = (event) => {
    const date = new Date(event).toISOString();

    setValues((prev) => ({
      ...prev,
      fromDate: date,
    }));
  };

  // Handle To Date
  const handleToDateChange = (event) => {
    const date = new Date(event).toISOString();

    setValues((prev) => ({
      ...prev,
      toDate: date,
    }));
  };

  // SEARCH
  const searchHandler = () => {
    let query = "";

    // Interpreter
    if (values.interpreter?._id) {
      query += `interpreter=${values.interpreter._id}`;
    }

    // Business Type
    if (values.businessType !== "") {
      query += `${
        query.length > 0 ? "&" : ""
      }businessType=${values.businessType}`;
    }

    // Date
    let filteredDate = "";

    if (values.fromDate) {
      filteredDate = `&fromDate=${values.fromDate}`;

      if (values.toDate) {
        filteredDate += `&toDate=${values.toDate}`;
      }
    }

    getCreditNoteReportHandler(`${query}${filteredDate}`);
  };

  // Clear Search
  const clearSearchHandler = () => {
    setValues({
      ...initialState,
    });

    getCreditNoteReportHandler("");
  };

  return (
    <React.Fragment>
      <div style={{ width: "100%" }}>
        <Paper className={classes.paper}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <EnhancedTableToolbar
              handleChange={handleChange}
              values={values}
              isInterpreters={interpreters || []}
              handleInterpreterInputChange={handleInterpreterInputChange}
              handleChangeAutoComplete={handleChangeAutoComplete}
              count={count}
              totalAmount={totalAmount}
              totalVAT={totalVAT}
              totalCredit={totalCredit}
              title="IP Credit Note Report"
              handleFromDateChange={handleFromDateChange}
              handleToDateChange={handleToDateChange}
              searchHandler={searchHandler}
              clearSearchHandler={clearSearchHandler}
            />
          </MuiPickersUtilsProvider>

          <CardItem
            values={values}
            hasData={creditNotes && creditNotes.length > 0}
            title="IP Credit Note Report"
            active={classes.paidStage}
            classes={classes}
            isLoading={loading}
            data={creditNotes}
            dense={dense}
            matches={matches}
          />
        </Paper>
      </div>
    </React.Fragment>
  );
};

export default IPCreditNoteReport;
